import { Box, Container, Divider, Grid, Typography } from '@mui/material'
import React from 'react'
import TelegramCard from './Component/TelegramCard'

function NotPermittedPage() {
  return (
    <Container maxWidth="md">
      <Grid container mt={4} rowSpacing={2}>
        <Grid item xs={12}>
          <Typography color={'text.primary'} textAlign="center" variant='h3' pb={1}>
            به ساناکش خوش آمدید
          </Typography>

          <Typography color={'text.primary'} textAlign="center" pb={1}>
            .ثبت نام شما با موفقیت انجام شده است
          </Typography>

          <Box py={1}>
            <Divider variant="middle" />
          </Box>

          <Typography color={'text.primary'} textAlign="center" pb={1} variant="h6" dir="rtl">
            لطفا در قسمت پروفایل، مدارک درخواستی را ارسال نمایید و برای تکمیل احراز هویت و استفاده از امکانات سایت با پشتیبانی تلگرام ساناکش تماس بگیرید.
          </Typography>

          <Typography color={"text.primary"} textAlign={"center"} variant='h6' dir="rtl">
            بعد از تکمیل فرایند احراز هویت، صفحه را رفرش کنید.
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <TelegramCard />
        </Grid>

        <Grid item xs={12}>

        </Grid>
      </Grid>


    </Container>
  )
}

export default NotPermittedPage